import React from 'react'
import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'
import type { BetLoopKambiShareCoupon } from '@core/Areas/BetLoop/types'
import { getKambiCouponBetType } from '@core/Areas/KambiSports/Player/helpers/getKambiCouponBetType'
import { Single, SameGameMulti, Multi } from './Components'

export const BetInfo: React.FC<{
  historyCoupon: BetLoopKambiShareCoupon | KambiHistoryCoupon
}> = ({ historyCoupon }) => {
  const betType = getKambiCouponBetType(historyCoupon)
  const outcomes = historyCoupon.outcomes ?? []

  if (betType === 'same-game-multi') {
    const { events, bets, betOffers } = historyCoupon
    const oddsPlayed = bets[0].betOddsBoosted ?? bets[0].playedOdds

    return (
      <SameGameMulti
        legCount={outcomes.length}
        event={events[0]}
        outcomes={outcomes}
        betOffers={betOffers}
        betStatus={bets[0].betStatus}
        playedOdds={oddsPlayed}
      />
    )
  }

  if (betType === 'multi') {
    return <Multi historyCoupon={historyCoupon} />
  }

  if (betType === 'single') {
    const { events, bets, betOffers } = historyCoupon
    const oddsPlayed = bets[0].betOddsBoosted ?? bets[0].playedOdds

    return (
      <Single
        betRef={bets[0].betRef}
        event={events[0]}
        outcome={outcomes[0]}
        betOffers={betOffers}
        betStatus={bets[0].betStatus}
        playedOdds={oddsPlayed}
      />
    )
  }

  return !PRODUCTION ? <div>Unknown Kambi Bet Type</div> : null
}
